import * as PIXI from 'pixi.js';
import LevelView from "./LevelView";
import EventManager from "./lib/EventManager";
import * as Events from "./Events";
import state from "./State";

const width = 20 * 32
const height = 15 * 32

const ratio = width / height

export const app = new PIXI.Application({
  width: 20*32,
  height: 15*32
})

document.body.appendChild(app.view);
if (process.env.NODE_ENV === 'development') (window as any).__PIXI_INSPECTOR_GLOBAL_HOOK__ &&  (window as any).__PIXI_INSPECTOR_GLOBAL_HOOK__.register({ PIXI: PIXI });

const resize = () => {

  EventManager.emit(Events.screenSizeChanged)

  const viewportRatio: number = window.innerWidth / window.innerHeight
  if (window.innerWidth < width) {
    state.orientation = 'portrait'
    if (viewportRatio > 1) {
      LevelView.el.angle = 0
    } else {
      // LevelView.el.scale.x = viewportRatio
      LevelView.el.angle = 90
      LevelView.el.x = height
      app.renderer.view.height = width
      app.renderer.view.width = height
      if (window.innerWidth < height) {
        LevelView.el.scale.x = window.innerWidth / height
        LevelView.el.scale.y = window.innerWidth / height
        LevelView.el.x = (window.innerWidth / height) * height
        app.renderer.view.height = width * (window.innerWidth / height)
        app.renderer.view.width = height * (window.innerWidth / height)
      }
    }
  } else {
    state.orientation = 'landscape'
    LevelView.el.angle = 0
    LevelView.el.x = 0
    app.renderer.view.height = height
    app.renderer.view.width = width
    LevelView.el.scale.x = 1
    LevelView.el.scale.y = 1
  }

}

resize()

window.addEventListener('resize', resize)
